import { useState } from 'react';
import { toast } from 'react-toastify';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function Contact() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const { name, email, phone, subject, message } = formData;

  function onChange(e) {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      // Save to Firestore
      await addDoc(collection(db, 'contactSubmissions'), {
        name,
        email,
        phone,
        subject,
        message,
        timestamp: serverTimestamp(),
        status: 'unread',
      });

      toast.success('Message sent successfully! We will contact you soon.');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });
    } catch (error) {
      console.error('Error submitting contact form:', error);
      toast.error('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="max-w-6xl mx-auto px-3">
      <h1 className="text-3xl text-center mt-6 font-bold">Contact Us</h1>
      <p className="text-center text-gray-600 mt-2 mb-8">
        Get in touch with us for any queries or support
      </p>

      <div className="flex flex-wrap items-start justify-between">
        {/* Contact Form */}
        <div className="w-full md:w-[67%] lg:w-[60%] mb-12 md:mb-6">
          <form onSubmit={onSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8">
            {/* Name */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Full Name *
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={onChange}
                required
                placeholder="Your Name"
                className="w-full px-4 py-3 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-slate-600"
              />
            </div>

            {/* Email */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={onChange}
                required
                placeholder="your@email.com"
                className="w-full px-4 py-3 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-slate-600"
              />
            </div>

            {/* Phone */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Phone Number *
              </label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={onChange}
                required
                placeholder="8409327568"
                className="w-full px-4 py-3 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-slate-600"
              />
            </div>

            {/* Subject */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Subject *
              </label>
              <input
                type="text"
                id="subject"
                value={subject}
                onChange={onChange}
                required
                placeholder="How can we help you?"
                className="w-full px-4 py-3 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-slate-600"
              />
            </div>

            {/* Message */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Message *
              </label>
              <textarea
                id="message"
                value={message}
                onChange={onChange}
                required
                rows="6"
                placeholder="Tell us more about your inquiry..."
                className="w-full px-4 py-3 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-slate-600"
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-blue-700 transition duration-150 ease-in-out hover:shadow-lg active:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>

        {/* Contact Info Sidebar */}
        <div className="w-full md:w-[30%] lg:w-[35%]">
          {/* Office Address */}
          <div className="bg-white shadow-md rounded px-6 py-6 mb-6">
            <h3 className="text-xl font-bold mb-4">Visit Our Office</h3>
            <div className="space-y-4">
              <div>
                <h4 className="font-semibold text-gray-700">Address</h4>
                <p className="text-gray-600">
                  H3WF+V89 Patna, Bihar<br />
                  25°35'49.8"N 85°04'24.1"E
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-700">Phone</h4>
                <p className="text-gray-600">8409327568</p>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-700">Email</h4>
                <p className="text-gray-600">info@pmdreammanors.com</p>
              </div>

              <div>
                <h4 className="font-semibold text-gray-700">Business Hours</h4>
                <p className="text-gray-600">
                  Monday - Saturday: 9:00 AM - 7:00 PM<br />
                  Sunday: 10:00 AM - 5:00 PM
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white shadow-md rounded overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3597.5891449089897!2d85.07042931502445!3d25.597166583733976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed590e1d39c539%3A0x3b1e3b4a7e8b4f3c!2sPatna%2C%20Bihar!5e0!3m2!1sen!2sin!4v1639132456789!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Office Location"
            ></iframe>
            <div className="p-4">
              <a
                href="https://www.google.com/maps/place/25%C2%B035'49.8%22N+85%C2%B004'24.1%22E"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 font-semibold"
              >
                View larger map →
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div className="bg-white shadow-md rounded px-6 py-6 mt-6">
            <h3 className="text-xl font-bold mb-4">Connect With Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 text-2xl"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-600 text-2xl"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-600 hover:text-pink-800 text-2xl"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 hover:text-blue-900 text-2xl"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
